import clsx from 'clsx';
import { T_Notification } from 'types/app.type';

import { IconCloseCircle } from '@/assets/icons';
import { SnacbarIcon } from '@/assets/icons/SnacbarIcon';
import { Button } from '@/components/core';
import { Size } from '@/hooks/useScreenSize';

import {
  closeIconContainerClassmap,
  notificationContainerClassMap,
  toastSubTitleClassmap,
} from './style';

interface Props {
  notification: T_Notification;
  dismissAction: (id: string) => void;
  engageAction: (id: string, url: string) => void;
  size: Size;
  notificationIndexId?: number;
}

export const Notification = ({
  notification,
  dismissAction,
  engageAction,
  size = 'sm',
  notificationIndexId,
}: Props) => {
  const renderActionBtn = (notificationItem: T_Notification) => {
    if (!notification.actionBtnUrl) return;

    return (
      <Button
        onClick={() => engageAction(notificationItem.id, notificationItem.actionBtnUrl)}
        variant="tertiary"
        colorMode="dark"
        className="!border-transparent !bg-color-background-button-tertiary-dakbg-alpha-8 !text-font-size-paragraph-body-xs !text-color-content-text-primary"
      >
        {notificationItem.actionBtnLabel}
      </Button>
    );
  };

  return (
    <div
      className="bg-color-neutral-matteBlack100"
      data-testid={`test-notification-${notificationIndexId}`}
    >
      <div className={clsx(notificationContainerClassMap[size])}>
        <div className="flex gap-spacing-2xs">
          <div>
            <SnacbarIcon width={18.49} height={17.69} />
          </div>
          <div>
            <div className={clsx(toastSubTitleClassmap[size])}>
              {notification.text ? (
                <>
                  {notification.title ? (
                    <span className="font-[700] text-color-content-text-primary">
                      {notification.title}:
                    </span>
                  ) : null}{' '}
                  {notification.text}{' '}
                  <a
                    href={notification.tcLink}
                    className={clsx(
                      toastSubTitleClassmap[size],
                      '!text-color-content-text-primary underline'
                    )}
                  >
                    {notification.tcLinkLabel}
                  </a>
                </>
              ) : null}
            </div>
            {notification.actionBtnUrl ? (
              <div data-testid="test-action-btn" className="py-[8px] md:block md:hidden">
                {renderActionBtn(notification)}
              </div>
            ) : null}
          </div>
        </div>

        <div className="flex justify-center gap-spacing-2xs">
          {notification.actionBtnUrl ? (
            <div data-testid="test-action-btn" className="sm:hidden md:block">
              {renderActionBtn(notification)}
            </div>
          ) : null}
          {notificationIndexId === 0 ? (
            <div
              className={clsx(closeIconContainerClassmap[size], 'flex items-start justify-center')}
              role="button"
              tabIndex={0}
              onClick={() => dismissAction(notification.id)}
              onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  dismissAction(notification.id);
                }
              }}
              data-testid="test-dismiss-action-icon"
            >
              <IconCloseCircle width={27} height={27} />
            </div>
          ) : (
            <div
              className="h-[27px] w-[27px]" // make width same as icon
              data-testid="test-dismiss-action-icon"
            />
          )}
        </div>
      </div>
    </div>
  );
};
